import {
  CartPaymentCardType,
  IApplePay,
  ICashAppPayment,
  ICommitOrderInput as ICommitOrderInputGQL,
  ICreditCardMetadataInput,
  IGooglePay,
  IPaymentInput,
  IPaypal,
  IVenmo,
} from 'generated/graphql-gateway';
import { IUsePriceOrderParams } from 'hooks/price-order/types';

export interface IPayment extends IPaymentInput {
  /** Contains supplemental data for CC transactions */
  ccMetadata?: ICreditCardMetadataInput & {
    ccExpiryMonth?: string;
    ccExpiryYear?: string;
  };
}

export interface ICommitOrderMutationInput extends Omit<ICommitOrderInputGQL, 'creditType'> {
  billingAddress?: {
    locality: string | null;
    postalCode: string;
    region: string | null;
    streetAddress: string | null;
    unitNumber?: string | null;
  };
  ccBin?: string | null;
  ccExpiryMonth?: string | null;
  ccExpiryYear?: string | null;
  ccLast4?: string | null;
  creditType?: CartPaymentCardType | null;
  fdAccessToken?: string;
  fdAccountId?: string;
  fdNonce?: string;
  fireOrderIn?: number | null;
  fullName?: string;
  rbiOrderId: string;
  payment?: IPayment | null;
  applePayDetails?: IApplePay;
  googlePayDetails?: IGooglePay;
  paypalDetails?: IPaypal;
  venmoDetails?: IVenmo;
  cashAppInput?: ICashAppPayment;
  distanceToStore?: number;
  checkoutData?: ICheckoutData;
}

export interface ICheckoutData {
  rewardsSaving?: number;
  savings?: number;
  subtotal: number;
  tax: number;
  total: number;
}

export interface ICommitOrderOptions extends ICommitOrderMutationInput {
  ccExpiry?: string | null;
  skipCoolingPeriod?: boolean;
}

export interface IUseCommitOrderParams extends Omit<IUsePriceOrderParams, 'cartEntries'> {
  onCompleted?(): void;
  rbiOrderId?: string | null;
  distanceToStore?: number;
  checkoutData?: ICheckoutData;
}

export interface ICommitOrderInput extends Omit<ICommitOrderOptions, 'rbiOrderId'> {}
